<div
    class="h-[70px] md:h-full w-full flex flex-row md:flex-col items-center justify-between md:px-3 px-4 md:pt-4 md:pb-6 md:bg-blurple-light bg-white">
    <!-- Desktop - Navbar top -->
    <div class="hidden md:flex flex-col items-center justify-center">
        <fm-logo-link class="hidden md:flex flex w-10 h-10" />
    </div>

    <!-- Desktop - Navbar bottom -->
    <div class="hidden md:flex flex-col items-center justify-end gap-3">
        <fm-people-link
            class="flex w-10 h-10"
            pTooltip="People"
            tooltipPosition="right"
            tooltipStyleClass="p-tooltip-fm-navigation" />
        <fm-refer-link class="flex w-10 h-10" />
        <fm-settings-link class="flex w-10 h-10" />
        <fm-help-link class="flex w-10 h-10" />
        <fm-profile-link class="flex w-10 h-10" />
    </div>

    <!-- Modile -->
    <div class="md:hidden flex flex-row items-center justify-around w-full">
        <fm-people-link class="flex w-10 h-10" />
        <fm-home-link class="flex w-10 h-10" />
        <fm-menu-link class="flex w-10 h-10" />
    </div>
</div>
